import { render } from "./PaymentPage.vue?vue&type=template&id=a95d3358"
import script from "./PaymentPage.vue?vue&type=script&lang=js"
export * from "./PaymentPage.vue?vue&type=script&lang=js"

import "./PaymentPage.vue?vue&type=style&index=0&id=a95d3358&lang=css"

import exportComponent from "/var/www/pd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__